import * as React from "react";
import { Grid, Button, LoadingSpinner, LoadingError } from "components/controls/widget";
import { useApplicationList, ContentPage } from "./store";
import PageTitle from "common/admin/PageTitle";
import PageContainer from "common/admin/PageContainer";
import PageContent from "common/admin/PageContent";
import { useApplication } from "../store";
import { ApplicationPage } from "../page/view"

const View = () => {

    const [{ selectedApplicationId, clubID }, listActions] = useApplicationList();
    const [state, { loadApplication }] = useApplication();

    React.useEffect(() => {
        if (selectedApplicationId) {
            loadApplication(selectedApplicationId, null, clubID);
        }
    }, []);


    const loading = state.loading;
    const showError = state.loadFailure;
    const showContent = !loading && !showError && state.entity?.id === selectedApplicationId;

    return <PageContainer>
        <PageTitle title="Přihláška člena" />
        <PageContent>
            <Grid container direction="column" spacing={24}>
                <Grid item>
                    <Button variant="outlined" onClick={() => listActions.goToPage(ContentPage.List)}>{'Zpět na seznam přihlášek členů'}</Button>
                </Grid>
                <Grid item>
                    {loading && <LoadingSpinner />}
                    {showError && <LoadingError />}
                    {showContent && <ApplicationPage />}
                </Grid>
            </Grid>
        </PageContent>
    </PageContainer>;
}

export {
    View as DetailView
}